import Nullstack from 'nullstack';
export default function IconDeviceAnalytics({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-device-analytics",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("rect", {
    x: "3",
    y: "4",
    width: "18",
    height: "12",
    rx: "1"
  }), "   ", Nullstack.element("line", {
    x1: "7",
    y1: "20",
    x2: "17",
    y2: "20"
  }), "   ", Nullstack.element("line", {
    x1: "9",
    y1: "16",
    x2: "9",
    y2: "20"
  }), "   ", Nullstack.element("line", {
    x1: "15",
    y1: "16",
    x2: "15",
    y2: "20"
  }), "   ", Nullstack.element("path", {
    d: "M8 12l3 -3l2 2l3 -3"
  }), " ");
}